export default {
    draft: 0,

    publishable: 4,
    published: 5
};